import React, {createContext, useLayoutEffect, useContext, useEffect, useRef, useState} from "react";
import CModal from '../components/UI/CModal';

export const ModalContext = createContext(null);

export const useModalContext = () => useContext(ModalContext);

export const EVENT_GET_PARENT_SCROLL = 'getScrollPosition';

/**
 * @param {boolean} showModals Toggle modals visibility
 * @param {boolean} lockPageScroll Указывает, нужно ли блокировать прокрутку страницы при открытии модального окна
 */
export const ModalContextProvider = ({ children, showModals = true, lockPageScroll = true }) => {
    const modalRef = useRef(null);
    const mountRef = useRef(null);
    const [modals, setModals] = useState([]);
    const [modalStyle, setModalStyles] = useState({});
    const [modalsVisibility, setModalsVisibility] = useState(showModals);

    useEffect(() => {
        /**  Флаг, указывающий, требуется ли блокировка прокрутки страницы */
        const isScrollLocked = modals.some(modal => modal.props?.lockPageScroll !== false);
        document.body.style.overflow = isScrollLocked ? 'hidden' : 'auto';
    }, [modals]);

    /** БЛОК ДЛЯ ПОЗИЦИОНИРОВАНИЯ МОДАЛОК В ВИДЖЕТЕ */
    useLayoutEffect(() => {
        if (window.self === window.top) {
            return;
        }

        window.addEventListener('message', handleParentMessage);

        return () => {
            window.removeEventListener('message', handleParentMessage);
        };
    }, []);

    useEffect(() => {
        setModalsVisibility(showModals);
    }, [showModals]);

    useEffect(() => {
        if (window.self === window.top || !modals.length) return;

        window.parent.postMessage({event: EVENT_GET_PARENT_SCROLL}, '*');
    }, [modals]);

    function handleParentMessage(event) {
        if (!event.data.hasOwnProperty('name') || event.data.name !== EVENT_GET_PARENT_SCROLL) {
            return;
        }

        setTimeout(() => {
            if (!mountRef.current) return;

            const _style = {
                position: 'fixed',
            }

            const modalRect = modalRef.current.getBoundingClientRect();
            const {height: parentHeight, frameRect} = event.data;
            let offsetTop = ((parentHeight - modalRect.height) / 2) - frameRect.top;

            if (offsetTop < 0) {
                offsetTop = 20;
            }
            
            if (offsetTop + modalRect.height > window.innerHeight) {
                _style.bottom = 20
                // offsetTop = offsetTop - ((offsetTop + modalRect.height) - frameRect.height + 20);
            } else {
                _style.top = offsetTop;
            }

            setModalStyles(_style);
        }, 100);
    }
    /** КОНЕЦ БЛОКА */

    function closeModalByIndex(index) {
        setModals(modals => {
            const modalsFilter = modals.filter((_, i) => i !== index);
            if (!modalsFilter.length) {
                mountRef.current = null;
            }
            return modalsFilter;
        });
    }

    function renderModal(modalComponent, modalProps = {}, content = null, showCurrentModal = true, appendTo) {
        if (!modalsVisibility || !showCurrentModal) {
            return;
        }

        mountRef.current = appendTo || document.body;

        let index;
        setModals((prev) => {
            index = prev.length;
            const onClose = (props) => {
                if (modalProps.onClose) {
                    modalProps.onClose(props);
                }
                closeModalByIndex(index);
            };
            return [
                ...prev,
                {component: modalComponent, props: {...modalProps, onClose}, content}
            ];
        });
        return index;
    }

    function handleBack() {
        setModals((prev) => {
            return prev.slice(0, -1);
        });
    }

    function closeModal() {
        mountRef.current = null;
        modals.forEach(modal => modal.props.onClose())
        setModals([]);
    }

    const isOpen = !!modals?.length;

    const context = {
        renderModal,
        closeModal,
        modalRef,
        modalIsOpen: isOpen,
        closeModalByIndex,
        setModalsVisibility,
    };

    return (
        <ModalContext.Provider value={context}>
            {children}
            {
                isOpen &&
                <CModal
                    modalRef={modalRef}
                    index={modals?.length}
                    isOpen={isOpen}
                    lockBody={false}
                    style={{...modalStyle}}
                    hasBack={modals?.length > 1}
                    onBack={() => handleBack()}
                    onClose={() => closeModal()}
                    appendTo={mountRef.current}
                >
                    {
                        React.createElement(
                            modals[modals.length - 1].component,
                            {
                                ...modals[modals.length - 1].props,
                            },
                            modals[modals.length - 1].content
                        )
                    }
                </CModal>
            }
        </ModalContext.Provider>
    )
}
